import Cookies from "js-cookie";
import { SimTypes } from "../../features/checkout/Types";
export const shopWareRedirectionHandler = (
  navigationPath: string,
  endPoint: string
) => {
  let swContextToken: any = Cookies.get("swContextToken");
  let idTokenValue: any = localStorage.getItem("accessToken");
  let currentuser: any = localStorage.getItem("currentuser");
  let subDomainData: any = localStorage.getItem("subDomainData");
  subDomainData = JSON.parse(subDomainData);
  currentuser = JSON.parse(currentuser);
  let encodedbrandUri = encodeURI(`https://${subDomainData?.brandUrl}/`);
  // if (idTokenValue) {
  let path = `${navigationPath}/${endPoint}/?`;
  if (swContextToken) {
    path = path + `token=${swContextToken}`;
  }
  if (swContextToken) {
    path = path + "&";
  }
  if (idTokenValue) {
    path = path + `firebase_token=${idTokenValue}`;
  }
  if (subDomainData?.subDomainName) {
    path = path + `&sub_domain=${subDomainData.subDomainName}`;
  }
  path = path + `&logged_in=${currentuser && currentuser.email ? true : false}`;
  window.location.assign(path);
  // swContextToken
  //   ? window.location.assign(
  //       path
  //     )
  //   : window.location.assign(
  //       `${navigationPath}/${endPoint}/?firebase_token=${idTokenValue}&logged_in=${
  //         currentuser && currentuser.email ? true : false
  //       }`
  //     );
  // } else {
  //   let path = `${navigationPath}/${endPoint}/?`;
  //   if(swContextToken) {path = path + `token=${swContextToken}&`};
  //   path = path + `logged_in=${currentuser && currentuser.email ? true : false}`;
  //   swContextToken
  //     ? window.location.assign(
  //         `${navigationPath}/${endPoint}/?token=${swContextToken}&logged_in=${
  //           currentuser && currentuser.email ? true : false
  //         }`
  //       )
  //     : window.location.assign(
  //         `${navigationPath}/${endPoint}/?logged_in=${
  //           currentuser && currentuser.email ? true : false
  //         }`
  //       );
  // }
};

export const shopwareAuthentication = () => {
  let idTokenValue: any = localStorage.getItem("accessToken");
  let currentUser: any = localStorage.getItem("currentuser");
  currentUser = JSON.parse(currentUser);
  let nameValues: any = currentUser?.displayName?.split(" ");
  let billingDetails: any = {
    salutation: "Mr",
    firstName: "Dummy123",
    lastName: "Dummy123",
    zipcode: "560098",
    city: "Bengaluru",
    company: "Dummy123",
    street: "Dummy123",
    department: "IT",
    title: "Dummy",
    phoneNumber: "9876543210",
    additionalAddressLine1: "Dummy123",
    additionalAddressLine2: "Dummy123",
    country: "India",
    countryState: "Karnataka",
  };
  let shippingDetails: any = {
    salutation: "Mr",
    firstName: "Dummy123",
    lastName: "Dummy123",
    zipcode: "560098",
    city: "Bengaluru",
    company: "Dummy123",
    street: "Dummy123",
    department: "IT",
    title: "Dummy",
    phoneNumber: "9876543210",
    additionalAddressLine1: "Dummy123",
    additionalAddressLine2: "Dummy123",
    country: "India",
    countryState: "Karnataka",
  };
  let payload: any = {
    data: {
      idToken: idTokenValue,
      registerCustomer: true,
      email: currentUser?.email,
      customerDetails: {
        salutation: "Mr",
        firstName: nameValues && nameValues[0],
        lastName: nameValues && nameValues[1],
        billingAddress: billingDetails && billingDetails,
        shippingAddress: shippingDetails && shippingDetails,
        birthdayDay: 14,
        birthdayMonth: 8,
        birthdayYear: 1947,
        title: "",
      },
    },
  };
  if (idTokenValue) return payload;
};

export const updateCartPayload = () => {
  let lineItemsInCart: any = localStorage.getItem("lineItems");
  lineItemsInCart = JSON.parse(lineItemsInCart);
  let planStoreData: any = localStorage.getItem("reachSelectedPlanDetail");
  planStoreData = JSON.parse(planStoreData);
  const linePreferenceData: any = {};
  planStoreData &&
    planStoreData.map((data: any, index: any) => {
      linePreferenceData["line" + (index + 1)] = {
        imei: data?.imei ? data.imei?.toString() : "",
        simPreference:
          data?.simPreference === SimTypes.eSim
            ? SimTypes.ESIM
            : SimTypes.phySim,
        plan: data?.plan,
        firstName: data?.firstName,
        lastName: data?.lastName,
        isPrimary: data?.isPrimary,
        reachPlanId: data?.plan.name,
      };
    });
  let productNumberWithPlanSelection: any =
    lineItemsInCart &&
    lineItemsInCart.find((data: any) =>
      data?.payload?.productNumber.match("DATA-")
    );
  let payload: any;
  if (productNumberWithPlanSelection) {
    let line: any = localStorage.getItem("reachSelectedPlanLine");
    line = JSON.parse(line);
    payload = {
      items: [
        {
          id: productNumberWithPlanSelection.id,
          payload: {
            quantity: planStoreData && parseInt(planStoreData?.length),
            linePreferences: linePreferenceData,
          },
        },
      ],
    };
  }
  return payload;
};

export const checkUserExist = () => {
  let currentuser: any = localStorage.getItem("currentuser");
  currentuser = JSON.parse(currentuser);
  if (currentuser?.email) {
    return true;
  }
};
